import ApiService from './api.service';

export default {
  getAccessLevel(businessId) {
    return ApiService.get(`business/${businessId}/accessLevel`);
  },
};



// WEBPACK FOOTER //
// ./src/services/access.service.js